export const qucikLoanPLV1 = ["postalCode", "state", "city", "propertyDesignation"];

export const detailedLoanPLV1 = ["address", "postalCode", "state", "city", "propertyDesignation"];
